import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import React from 'react';
import {CustomSelect} from '../../../common/components/StyledComp';
import styled from 'styled-components';
import {USER_BRANDS_ORDER_BY} from '../../../common/constants';

const MargedDiv = styled.div`
  margin: 5px;
`;

const SelectOrder = ({t, onChange, value, allowNull, ...props}) => {

  return (
    <MargedDiv>
      <CustomSelect
        name="orderBy"
        onChange={onChange}
        value={value}
        absolute
        {...props}>
        <option value={USER_BRANDS_ORDER_BY.LAST_RECEIPT}>{t('orderLastTicket')}</option>,
        <option value={USER_BRANDS_ORDER_BY.BRAND_NAME}>{t('orderBrand')}</option>,
      </CustomSelect>
    </MargedDiv>
  );
};

SelectOrder.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  allowNull: PropTypes.bool,
};

SelectOrder.defaultProps = {
  allowNull: false,
};

export default withTranslation('ticket')(SelectOrder);
